module.exports = __webpack_public_path__ + "static/media/EURJPY.92da21bd.svg";